import "./index.css"
import React, { memo } from "react"
import { getThemeColor } from "utils/utils"
import { useHistory } from "react-router-dom"
import { HOME_PATH } from "routes/path"
import IconFont from "../iconfont/IconFont"

/**
 * 返回首页
 */
export default memo(function BackHome({ 
    theme,
    path = HOME_PATH,
}) {
    const history = useHistory()
    const backgroundColor = getThemeColor(theme).default

    return (
        <div
            className='back-home'
            style={{ backgroundColor }}
            onClick={() => history.replace(path)}            
        >
            <IconFont name='back' size={9} color='#ffffff' />
            <span className='back-home__label'>首页</span>
        </div>
    )
})